import React, { useState } from "react";
import { toHalfWidth } from "../../helpers/validate-helper"; // same helper you're using
import { useIntl } from "react-intl";

interface IPhoneInputProps {
  value: string; 
  type:string;
  className:string;
  name:string;
  onChange: (value: string) => void;
  onEnter?: () => void;
  disabled?: boolean;
}

const PhoneNumberInput: React.FC<IPhoneInputProps> = ({
  value,
  type,
  name,
  className,
  onChange,
  onEnter,
  disabled = false
}) => {
  const [isComposing, setIsComposing] = useState(false);
  const intl = useIntl();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = event.target.value;

    if (!isComposing) {
      newValue = toHalfWidth(newValue);

      // add 0 prefix if missing
      if (newValue.length > 0 && newValue.charAt(0) !== "0") {
        newValue = "0" + newValue;
      }
    }

    onChange(newValue);
  };

  const handleCompositionStart = () => {
    setIsComposing(true);
  };

  const handleCompositionEnd = (event: React.CompositionEvent<HTMLInputElement>) => {
    setIsComposing(false);
    let newValue = toHalfWidth(event.currentTarget.value);

    if (newValue.length > 0 && newValue.charAt(0) !== "0") {
      newValue = "0" + newValue;
    }

    onChange(newValue);
  };

  return (
    <input
      type="text"
      name={name}
      className={className}
      disabled={disabled}
      value={value}
      onChange={handleChange}
      onCompositionStart={handleCompositionStart}
      onCompositionEnd={handleCompositionEnd}
    />
  );
};

export default PhoneNumberInput;
